"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default() {
  var _console;
  /* eslint-disable no-console */


  (_console = console).log.apply(_console, arguments);
};

exports.default = _default;